import { Modal } from '@mui/material';
import { useContext } from 'react';
import { ViContext } from '../../context/ViContext';
import { setCookie } from '../../common/func/cookieFunc';

export default function Intention(props) {
	const modalAddCookie = () => {
		const expireDate = new Date();
		expireDate.setDate(expireDate.getDate() + 7);
		setCookie('IntentionModalNoMoreView', true, expireDate);
		props.setOpen(false);
	};

	return (
		<Modal open={props.open} onClose={() => props.setOpen(false)}>
			{/* <!-- 기획의도 모달 팝업 --> */}
			<section className="modalSection" tabIndex="-1">
				<div className="modalPaper">
					<div className="modalHead">
						<div type="button" className="tit">
							<img src="img/headerIcon01.png" alt="icon" />
							기획의도
						</div>
						<button
							className="closeIconButton"
							onClick={() => props.setOpen(false)}
						>
							<img src="img/popCloseBtn.png" alt="닫기" />
						</button>
					</div>

					<div className="modalBody">
						<div className="HeadingBox">
							<h1 className="text-heading-sm">
								공간으로 보는 전국의 新경제지도
							</h1>
							<h3 className="text-heading-lg">
								지역경제 활력도가 높은 지역은 어디일까
							</h3>
						</div>
						<div className="Content">
							지역경제의 영향이나 변동을 파악하기 위해 공공 및 민간데이터를 융합
							활용하여 다양한 공간단위로 지역경제 특성을 분석할 수 있는
							<span className="bold"> '지역활력지수(Vitality Index)'</span>를
							개발하였습니다. 지역활력지수(Vitality Index)는 지역의 생산과
							소비활동을 중심으로, 지역경제의 상태와 변화상의 지속적인
							모니터링을 위해{' '}
							<span className="bold">
								'해당 지역에서 발생하는 인구와 소비, 생산과 관련된 활동'
							</span>
							을 나타내는 지표입니다.
							<br />
							<br />
							지역경제 생태계를 구성하는 생산과 소비 측면의 활동성 측정을 위해,
							경제활동의 주체가 되는 해당 지역의 인구기반 및 활동성, 경제활동을
							구성하는 생산측면의 활동성, 생산의 밑바탕이 되는 소비 측면의
							활동성 관련 지표를 검토 · 선정하였습니다. 세부지표는 기존
							통계데이터의 한계를 보완하여 민간 빅데이터를 적극 활용하였으며,
							지표의 시의성, 데이터 구득 가능성 및 분석가능성 등을 고려하여
							지표를 개발하였습니다. 지역활력지수의 지표체계는 생산과 소비에
							대한 <span className="bold">'경제활력'</span>과 경제활동의 주체가
							되는 <span className="bold">'인구활력'</span>
							으로 구분하여 세부지표를 구성하였으며, '경제활력'은 다시{' '}
							<span className="bold">'생산활력'</span>과{' '}
							<span className="bold">'소비활력'</span>으로 구분하여 총 3개의
							영역으로 세부지표를 구성하였습니다.
							<br />
							<br />
							전국을 대상으로 지역활력지수 지표체계를 적용한 지역경제 활력도를
							시군구 및 읍면동 단위로 측정하였으며,
							<span className="bold">'인구', '소비', '생산'</span> 등 부문별
							활력도 및 이를 종합한 지역활력도 분석결과를 누구나 탐색·활용할 수
							있도록 <span className="bold">'KRIHS 인터랙티브 리포트'</span>{' '}
							콘텐츠로 구축하였습니다. 사용자가 공간단위별 분석결과를 비교할 수
							있도록 하였으며, 부문별 가중치를 적용하여 관심지역의 활력도를
							측정할 수 있도록 설계하였습니다.
							<br />
							<br />
							이 리포트는 국토연구원 기본과제 「지역경제 모니터링을 위한
							지역활력지수(Vitality Index) 개발 및 활용방안 연구」 (2022) 수행의
							일환으로 작성되었습니다.
							<br />
							<br />
						</div>

						<div className="Content">
							<span className="bold">작성 및 문의: </span>
							국토연구원 이영주 연구위원(leeyj@krihs.re.kr), 임은선
							선임연구위원(esim@krihs.re.kr)
							<br />
							<span className="bold">작성연월: </span>
							2022년 12월
							<br />
							<br />※ 이영주, 임은선, 정우성.
							<a
								href="https://www.krihs.re.kr/publica/reportView.es?mid=a10102000000&pageIndex=1&searchCondition=2&searchKeyword=%EC%9D%B4%EC%98%81%EC%A3%BC&num=000003639440"
								target="_blank"
								rel="noreferrer"
								style={{ color: 'blue' }}
							>
								2022. 지역경제 모니터링을 위한 지역활력지수(Vitality Index) 개발
								및 활용방안.
							</a>
							국토연구원
							{/* <br />※ 이 인터랙티브 리포트는 <span className="bold">「2023년 국토모니터링 사업 위탁」</span>
              연구(국토교통부 발주 ; 국토연구원 수행) 내용을 토대로 제작되었음 */}
						</div>
					</div>

					<footer className="modalFooter">
						<div className="AddCookieBox">
							<div className="AddCookieButton" onClick={modalAddCookie}>
								<img src="img/popCloseBottomBtn.png" alt="일주일간 보지않기" />
								<span>일주일간 보지않기</span>
							</div>
						</div>
					</footer>
				</div>
			</section>
		</Modal>
	);
}
